<mat-form-field color="accent" class="app-form-field" [appearance]="'fill'">
  <mat-label>{{ 'users.user-form.organization-unit' | translate }}</mat-label>
  <input matInput autocomplete="not" [formControlName]="controlKey" [matAutocomplete]="autocompleteRef" />
  <mat-autocomplete #autocompleteRef="matAutocomplete">
    <mat-option *ngFor="let item of itemsInternal" [value]="item.value">
      {{ item.label }}
    </mat-option>
  </mat-autocomplete>
  <app-pre *ngIf="0" [obj]="itemsInternal"></app-pre>
  <mat-error *ngFor="let err of errorsArray; trackBy: trackBy">
    {{ displayErrorMessage(err) }}
  </mat-error>
</mat-form-field>